var InputDataTestIdEnum = /* @__PURE__ */ ((InputDataTestIdEnum2) => {
  InputDataTestIdEnum2["INPUT_CONTAINER"] = "input-container";
  InputDataTestIdEnum2["INPUT_START_ICON"] = "start-icon";
  InputDataTestIdEnum2["INPUT_END_ICON"] = "end-icon";
  InputDataTestIdEnum2["INPUT_CLEAR_BUTTON"] = "clear-button";
  return InputDataTestIdEnum2;
})(InputDataTestIdEnum || {});
export {
  InputDataTestIdEnum
};
